import { MakeCall } from './createMakeCall';

const deleteUser = (makeCall: MakeCall) => (userId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/user/${userId}`);
export { deleteUser };
